import {
  DensityUnits as PrismaDensityUnits,
  StateOfMatter as PrismaStateOfMatter,
  UnitType as PrismaUnitType,
} from "encamp-prisma/generated/browser";
import { UnitType as GraphqlUnitType } from "generated-graphql/graphql";

// Oak's generated GraphQL enums and encamp-shared's Prisma enums carry the
// same runtime strings but are distinct TypeScript types. Narrowing by value
// lookup gets us the Prisma member the conversion helpers (`convert`) expect
// without a cast, and drops anything unrecognized instead of trusting it.

/**
 * The other direction: a server-supplied unit string narrowed to the GraphQL
 * enum, so display helpers can be handed a typed unit without a cast.
 */
export function toGraphqlUnitType(value: string | null | undefined): GraphqlUnitType | null {
  if (!value) return null;
  return Object.values(GraphqlUnitType).find((member) => member === value) ?? null;
}

export function toPrismaUnitType(value: string | null | undefined): PrismaUnitType | null {
  if (!value) return null;
  return Object.values(PrismaUnitType).find((member) => member === value) ?? null;
}

export function toPrismaDensityUnits(value: string | null | undefined): PrismaDensityUnits | null {
  if (!value) return null;
  return Object.values(PrismaDensityUnits).find((member) => member === value) ?? null;
}

/**
 * A chemical's state-of-matter list narrowed member by member. Needed by the
 * Oregon branch of the jurisdiction unit allowlist, which is the only rule that
 * varies by state of matter. Unrecognized members are dropped rather than
 * trusted, exactly as the single-value helpers above do.
 */
export function toPrismaStateOfMatter(
  values: readonly string[] | null | undefined
): PrismaStateOfMatter[] {
  if (!values) return [];
  return values.flatMap((value) => {
    const member = Object.values(PrismaStateOfMatter).find((candidate) => candidate === value);
    return member ? [member] : [];
  });
}
